export const LEGACY_CHANNEL_API_ROOT = 'Jha.Web.Treasury.Channel.API';
export const LEGACY_BO_API_ROOT = 'Jha.Web.Treasury.BackOffice.API';
export const CHANNEL_API_ROOT = 'bff/nag/a/treasury-channel/api';
export const BO_API_ROOT = 'a/treasury-backoffice/api';
